import React, { useCallback, useContext } from 'react'
import { Step4Styles } from './Style'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { Words } from 'pages'
import { queryClient as qc, statuses } from 'keys'
import { getWordDefsFetch } from 'store/middlewares/words.crud'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { changeItem } from 'utils/array'
import { updateAssessmentStatusFetch, uploadAudioFileFetch } from 'store/middlewares/assessment.crud'

const Step4 = () => {
    const { setFinishFlag, Mp3Recorder, stopRecord, setAssessments, assessments, setBlobURL, setAudioURL, audioChunks, setAudioChunks, wordDefs, assessmentDef, assessment, currentStep, setCurrentStep,finishRecord } = useContext(PerformAssessmentContext)
    const queryClient = useQueryClient()

    const { mutateAsync: updateAssessmentStatus } = useMutation({
        mutationFn: updateAssessmentStatusFetch
    })

    const { mutateAsync: uploadFile } = useMutation({
        mutationFn: uploadAudioFileFetch
    })

    const wordDefsData = useQuery({
        queryFn: [qc.wordDefs, assessment?.reading_assessment_def_id],
        enabled: !!assessment?.reading_assessment_def_id,
        queryFn: async ({ signal }) => {
            const { data } = await getWordDefsFetch({ signal, id: assessment?.reading_assessment_def_id })
            return data.word_defs
        },
        refetchOnWindowFocus: false
    })

    const uploadRecord = useCallback(async (blobURL) => {
        //update assessment status to UPLOADING
        await updateAssessmentStatus({
            status: statuses.uploading,
            sub_status: null,
            id: assessment.id
        })
        const currectAssessmentIndex = assessments.findIndex((ass) => ass.id == assessment.id)
        if (currectAssessmentIndex != -1) {
            const nAssessments = changeItem(assessments, currectAssessmentIndex, { ...assessment, status: statuses.uploading })
            setAssessments(nAssessments)
        }
        // //upload file to S3
        await uploadFile({ id: assessment.id, file: blobURL })
        queryClient.invalidateQueries({ queryKey: [qc.assessments] })
        queryClient.invalidateQueries({ queryKey: [qc.dashboard] })
    }, [assessment])

    // const stopRecord = useCallback(() => {
    //     Mp3Recorder
    //         ?.stop()
    //         ?.getMp3()
    //         ?.then(([buffer, blob]) => {
    //             let nAudioChunks = [...audioChunks, blob]
    //             setAudioChunks(nAudioChunks);
    //             const audioBlob = new Blob(nAudioChunks, { type: 'audio/mp3' });
    //             uploadRecord(audioBlob)
    //         }).catch((e) => {
    //             console.log(e)
    //         });
    // }, [audioChunks, Mp3Recorder])

    const goNextStep = useCallback(() => {
        setFinishFlag(true)
        finishRecord()
        setTimeout(() => {
            setCurrentStep(0)
        }, 1000)
    }, [audioChunks])

    return (
        <Step4Styles>
            {wordDefsData?.data &&
                <Words
                    print={true}
                    type={assessmentDef?.visible_type}
                    name={assessmentDef?.name}
                    words={wordDefsData?.data}
                    student={true}
                    finishPerfom={goNextStep}
                />}
        </Step4Styles>
    )
}

export default Step4